import "./Rentals.module.css";
import MainNavigation from "@/reusable_sections/Header";
import RealEstateAdvocacy from "./sections/RealEstateAdvocacy";
import FindYourSpace from "./sections/FindYourSpace";
import Inquiry from "./sections/Inquiry";
import Footer from "@/reusable_sections/Footer";
import Profile from "./sections/Profile";
import PropertyShowcase from "./sections/PropertyShowcase";
export default function RentalsPage() {
  return <div>
      <MainNavigation />
      <RealEstateAdvocacy />
      <Inquiry />
      <FindYourSpace />
      <Profile />
      <PropertyShowcase />
      <Footer />
    </div>;
}